import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { postRequest } from '../../requestUtils';
import './ToggleUpcomingNotification.scss';
var ToggleUpcomingNotification = /*#__PURE__*/function (_Component) {
  function ToggleUpcomingNotification(props) {
    var _this;
    _classCallCheck(this, ToggleUpcomingNotification);
    _this = _callSuper(this, ToggleUpcomingNotification, [props]);
    _this.state = {
      notify: props.notify,
      isExpanded: false
    };
    _this.showComments = _this.showComments.bind(_this);
    _this.toggleNotification = _this.toggleNotification.bind(_this);
    return _this;
  }
  _inherits(ToggleUpcomingNotification, _Component);
  return _createClass(ToggleUpcomingNotification, [{
    key: "showComments",
    value: function showComments() {
      this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      });
    }
  }, {
    key: "toggleNotification",
    value: function toggleNotification() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        csrfToken = _this$props.csrfToken,
        toggleNotificationUrl = _this$props.toggleNotificationUrl;
      var notify = this.state.notify;
      postRequest(toggleNotificationUrl, {
        project_id: id
      }, csrfToken).then(function () {
        _this2.setState({
          notify: !notify
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        notify = _this$state.notify,
        isExpanded = _this$state.isExpanded;
      return /*#__PURE__*/React.createElement("div", {
        className: "consultant-upcoming-opportunity"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-action-header"
      }, "Switch on the alert for this UPCOMING opportunity!"), /*#__PURE__*/React.createElement("p", {
        className: "project-action-description"
      }, "Receive an email notification when this opportunity begins accepting applications."), /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this3.toggleNotification();
        },
        role: "button",
        tabIndex: 0,
        className: "body-text-2 medium-weight upcoming-opportunity-notification-toggle"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa".concat(notify ? 's' : 'r', " fa-bell")
      }), /*#__PURE__*/React.createElement("span", null, "Email alert switched ".concat(notify ? 'ON' : 'OFF')), /*#__PURE__*/React.createElement("div", {
        className: "switch"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: notify,
        readOnly: true
      }), /*#__PURE__*/React.createElement("span", {
        className: "slider round"
      }))), /*#__PURE__*/React.createElement("hr", {
        className: "d-none d-sm-block mb-4"
      }), /*#__PURE__*/React.createElement("h3", null, "What is an upcoming opportunity?"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        className: "body-text-2 medium-weight ".concat(isExpanded ? 'hide' : 'show', " upcoming-opportunity-read-more"),
        tabIndex: 0,
        role: "link",
        onClick: function onClick() {
          return _this3.showComments();
        }
      }, "Read More")), /*#__PURE__*/React.createElement("div", {
        className: "mt-8 body-text-2 ".concat(isExpanded ? 'show' : 'hide')
      }, /*#__PURE__*/React.createElement("div", null, "It\u2019s a project whose application process isn\u2019t opened yet because the Employer and Clora are still fine-tuning final details.", /*#__PURE__*/React.createElement("h3", {
        className: "mt-40"
      }, "When will I be able to apply?"), /*#__PURE__*/React.createElement("div", {
        className: "mt-8"
      }, "Once the project becomes an Open Opportunity, you will be able to start the application process. If you switch on the alert, you will be instantly notified and become an early candidate.")), /*#__PURE__*/React.createElement("div", {
        className: "mt-8"
      }, /*#__PURE__*/React.createElement("a", {
        className: "medium-weight",
        tabIndex: 0,
        role: "link",
        onClick: function onClick() {
          return _this3.showComments();
        }
      }, "Read Less"))));
    }
  }]);
}(Component);
ToggleUpcomingNotification.propTypes = {
  id: PropTypes.number.isRequired,
  toggleNotificationUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  notify: PropTypes.bool.isRequired
};
export default ToggleUpcomingNotification;